import { render, staticRenderFns } from "./HomeworkPlaningMobile.vue?vue&type=template&id=1d50b850"
import script from "./HomeworkPlaningMobile.vue?vue&type=script&lang=js"
export * from "./HomeworkPlaningMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d50b850')) {
      api.createRecord('1d50b850', component.options)
    } else {
      api.reload('1d50b850', component.options)
    }
    module.hot.accept("./HomeworkPlaningMobile.vue?vue&type=template&id=1d50b850", function () {
      api.rerender('1d50b850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/homework/HomeworkPlaningMobile.vue"
export default component.exports